import React from "react";
import { useTranslation } from "react-i18next";
import { Check, X } from "lucide-react";
import {
  PASSWORD_RULE_IDS,
  evaluatePassword,
  passwordsMatch,
} from "../../lib/passwordPolicy";

/** The five password requirements, each rendered as its own line, plus the
 *  optional confirmation-match line. Used by registration and password reset so
 *  both screens state exactly the same rules. */
export const PasswordRules = ({ value, confirmation, showMatch = false, testIdPrefix }) => {
  const { t } = useTranslation();
  const { rules } = evaluatePassword(value);
  const items = PASSWORD_RULE_IDS.map((id) => ({
    id,
    ok: rules[id],
    label: t(`password.rule_${id}`),
  }));
  if (showMatch) {
    items.push({
      id: "match",
      ok: passwordsMatch(value, confirmation),
      label: t("password.rule_match"),
    });
  }

  return (
    <div data-testid={`${testIdPrefix}-password-requirements`}>
      <div className="qw-help">{t("password.requirements_title")}</div>
      <ul className="qw-pw-rules">
        {items.map((item) => (
          <li
            key={item.id}
            className={item.ok ? "ok" : ""}
            data-ok={item.ok ? "true" : "false"}
            data-testid={`${testIdPrefix}-password-rule-${item.id}`}
          >
            <span className="qw-pw-rule-mark" aria-hidden="true">
              {item.ok ? <Check size={14} strokeWidth={2.5} /> : <X size={14} strokeWidth={2.5} />}
            </span>
            {item.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRules;
